import axios from "axios";
import router from './router'
import {  h } from 'vue';
import { Modal,notification } from 'ant-design-vue';

const api = process.env.VUE_APP_BASEURL;
const axiosRequest = axios.create({
    baseURL: api,
    timeout: 20000,
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_VENDOR_TOKEN')}`,
        // Content-Type: `multipart/form-data`
        // account: window.localStorage.getItem("selectedAccount"),
        // accountIndex: window.localStorage.getItem("accountIndex")
    }
});

// RESPONSE
// Add a response interceptor
axiosRequest.interceptors.response.use(
    function(response) {
        // Do something with response data
        if (response.status == 201) {
            notification['success']({
                message: 'Success',
                description:  h('div', {}, [
                    h('p', response.data.message)
                ]),
               
            });
        }else if(response.status == 202){
            notification['success']({
                message: 'Success',
                description:  h('div', {}, [
                    h('p', response.data.message)
                ]),
               
            });
        }else if(response.status == 204){
            notification['success']({
                message: 'Success',
                description:  h('div', {}, [
                    h('p', response.data.message)
                ]),
               
            });
        }
        return response;
    },
    function(error) {
        // Do something with response error

        if (error.response.status == 401) {
            window.localStorage.removeItem('PAYMENT_PORTAL_VENDOR_TOKEN')
            window.localStorage.removeItem('PAYMENT_PORTAL_VENDOR_ID')
            router.push('/login')
        }
        if (error.response.status == 422) {
            const item = error.response.data.errors;
            let errors = "";
            for (const key in item) {
                errors += `${item[key]}`;
                break
            }

            notification['error']({
                message: errors,
                description: ''
               
            });
        }

        if (error.response.status == 500) {
            notification['error']({
                message: error.response.data.message,
                description: '',
               
            });
        }

        // if(error.response.status == undefined){
        //     router.push('/personnel/login')
        // }


        return Promise.reject(error);
    }
);

export default axiosRequest;
// function else if() {
//     throw new Error("Function not implemented.");
// }

